import React from 'react'
import { Text } from '../../../../styles/reactnative'
import PSlipage from 'app/components/PSlipage'

export const CanvasOvsPersonColumn = (mutate, token, edit, setEdit, uid) => {
	return [
		{
			title: '구분코드',
			dataIndex: 'code',
			align: 'center',
			key: 'code',
			width: 80,
			render: (text, record) => {
				return <Text>{text}</Text>
			},
		},
		{
			title: '구분이름',
			dataIndex: 'groupname',
			key: 'groupname',
			align: 'center',
			render: (text, record) => {
				return <Text style={{ fontWeight: 'bold' }}>{text}</Text>
			},
		},
		{
			title: '거래소',
			dataIndex: 'exchange_name',
			align: 'center',
			key: 'exchange_name',
			render: (text, record) => {
				return <Text>{text}</Text>
			},
		},
		{
			title: '종목코드',
			dataIndex: 'pairs',
			key: 'pairs',
			render: (text, record) => {
				return (
					<Text
						style={{
							backgroundColor: record?.person
								? 'lightblue'
								: 'white',
						}}>
						{text}
					</Text>
				)
			},
		},
		{
			title: '슬리피지',
			dataIndex: 'slip',
			align: 'center',
			key: 'slip',
			render: (text, record) => {
				return <PSlipage user_id={uid} ep_id={record?.id} />
			},
		},
	]
}
